import { s } from '../lib/style.js';

export function Foundation({ v }) {
  return (
    <section
      id="foundation"
      style={s("scroll-margin-top:80px;border-top:1px solid var(--line);background:var(--panel);")}
    >
      <div
        style={s("max-width:1220px;margin:0 auto;padding:clamp(28px,3vw,44px) clamp(20px,4vw,28px) clamp(40px,5vw,64px);")}
      >
        <div
          style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(300px,100%),1fr));gap:clamp(28px,4vw,56px);align-items:end;")}
        >
          <div style={s("display:flex;flex-direction:column;")}>
            <div
              style={s("align-self:flex-start;display:inline-flex;align-items:center;margin-bottom:18px;padding:9px 20px;border-radius:999px;background:#FFFFFF;border:1px solid rgba(18,49,56,0.12);box-shadow:0 2px 10px rgba(18,49,56,0.06);font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
            >
              The foundation
            </div>
            <h2
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(32px,4.2vw,54px);line-height:1.04;letter-spacing:-0.032em;margin:0;color:var(--text);")}
            >
              The work your team repeats,
              {' '}
              <span style={s(v.kwLight)}>
                already built in.
              </span>
            </h2>
          </div>
          <p style={s("margin:0 0 6px;font-size:18px;line-height:1.65;color:var(--muted);")}>
            Every recurring task a brand team does, captured as something you can run in seconds — starting with the business review.
          </p>
        </div>
        <div style={s("height:1px;margin:clamp(32px,4vw,48px) 0 0;background:rgba(18,49,56,0.16);")} />
        <div
          style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(320px,100%),1fr));gap:1px;background:rgba(18,49,56,0.16);")}
        >
          <div
            className="hv-11"
            style={s("display:flex;flex-direction:column;padding:clamp(28px,3vw,36px) clamp(24px,2.6vw,34px);background:var(--panel);transition:background .3s ease;")}
          >
            <div
              style={s("display:flex;align-items:baseline;justify-content:space-between;gap:16px;margin-bottom:18px;")}
            >
              {' '}
              <span
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(48px,4.6vw,64px);line-height:0.9;letter-spacing:-0.04em;color:rgba(18,49,56,0.14);")}
              >
                01
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
              >
                reviews
              </span>
              {' '}
            </div>
            <div
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(22px,2vw,25px);line-height:1.14;letter-spacing:-0.024em;text-wrap:pretty;color:var(--text);margin-bottom:10px;")}
            >
              Performance & business reviews
            </div>
            <div style={s("font-size:16px;line-height:1.6;color:var(--muted);")}>
              The weekly and monthly story of the business, assembled for you — so the team spends its time deciding, not building slides.
            </div>
            <div style={s("margin-top:auto;")}>
              <div
                style={s("position:relative;overflow:hidden;margin-top:26px;border-radius:12px;border:1px solid rgba(18,49,56,0.12);background:#FFFFFF;padding:18px;height:156px;display:flex;flex-direction:column;justify-content:flex-end;")}
              >
                <div
                  aria-hidden="true"
                  style={s("position:absolute;inset:0;pointer-events:none;background-image:linear-gradient(rgba(18,49,56,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(18,49,56,0.045) 1px,transparent 1px);background-size:26px 26px;")}
                />
                <div style={s("position:relative;display:flex;align-items:flex-end;gap:8px;height:88px;")}>
                  <div
                    style={s("flex:1;height:38%;border-radius:5px 5px 2px 2px;background:linear-gradient(180deg,#2E7A72 0%,#5B9A96 100%);opacity:0.34;")}
                  />
                  <div
                    style={s("flex:1;height:54%;border-radius:5px 5px 2px 2px;background:linear-gradient(180deg,#2E7A72 0%,#5B9A96 100%);opacity:0.43000000000000005;")}
                  />
                  <div
                    style={s("flex:1;height:46%;border-radius:5px 5px 2px 2px;background:linear-gradient(180deg,#2E7A72 0%,#5B9A96 100%);opacity:0.52;")}
                  />
                  <div
                    style={s("flex:1;height:70%;border-radius:5px 5px 2px 2px;background:linear-gradient(180deg,#2E7A72 0%,#5B9A96 100%);opacity:0.6100000000000001;")}
                  />
                  <div
                    style={s("flex:1;height:60%;border-radius:5px 5px 2px 2px;background:linear-gradient(180deg,#2E7A72 0%,#5B9A96 100%);opacity:0.7;")}
                  />
                  <div
                    style={s("flex:1;height:84%;border-radius:5px 5px 2px 2px;background:linear-gradient(180deg,#2E7A72 0%,#5B9A96 100%);opacity:0.79;")}
                  />
                  <div
                    style={s("flex:1;height:96%;border-radius:5px 5px 2px 2px;background:linear-gradient(180deg,#D9A03C 0%,#EBC079 100%);opacity:1;")}
                  />
                </div>
                <div
                  style={s("position:relative;display:flex;align-items:center;justify-content:space-between;margin-top:14px;")}
                >
                  {' '}
                  <span
                    style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:var(--muted);")}
                  >
                    Wk 26 → Wk 32
                  </span>
                  {' '}
                  <span
                    style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;padding:5px 9px;border-radius:999px;background:#2E7A72;color:#FFFFFF;")}
                  >
                    +8.4% vs LY
                  </span>
                  {' '}
                </div>
              </div>
            </div>
          </div>
          <div
            className="hv-11"
            style={s("display:flex;flex-direction:column;padding:clamp(28px,3vw,36px) clamp(24px,2.6vw,34px);background:var(--panel);transition:background .3s ease;")}
          >
            <div
              style={s("display:flex;align-items:baseline;justify-content:space-between;gap:16px;margin-bottom:18px;")}
            >
              {' '}
              <span
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(48px,4.6vw,64px);line-height:0.9;letter-spacing:-0.04em;color:rgba(18,49,56,0.14);")}
              >
                02
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
              >
                insight
              </span>
              {' '}
            </div>
            <div
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(22px,2vw,25px);line-height:1.14;letter-spacing:-0.024em;text-wrap:pretty;color:var(--text);margin-bottom:10px;")}
            >
              Consumer, category & competitive insight
            </div>
            <div style={s("font-size:16px;line-height:1.6;color:var(--muted);")}>
              The trends, categories, and shifts that actually move the brand.
            </div>
            <div style={s("margin-top:auto;")}>
              <div
                style={s("position:relative;overflow:hidden;margin-top:26px;border-radius:12px;border:1px solid rgba(18,49,56,0.12);background:#FFFFFF;padding:18px;height:156px;display:flex;flex-direction:column;justify-content:flex-end;")}
              >
                <div
                  aria-hidden="true"
                  style={s("position:absolute;inset:0;pointer-events:none;background-image:linear-gradient(rgba(18,49,56,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(18,49,56,0.045) 1px,transparent 1px);background-size:26px 26px;")}
                />
                <div style={s("position:relative;display:flex;flex-direction:column;gap:12px;")}>
                  <div style={s("display:flex;align-items:center;gap:10px;")}>
                    {' '}
                    <span style={s("width:96px;flex:none;font-size:11px;color:var(--muted);")}>
                      Your brand
                    </span>
                    {' '}
                    <span
                      style={s("flex:1;height:8px;border-radius:999px;background:rgba(18,49,56,0.08);overflow:hidden;display:block;")}
                    >
                      <span
                        style={s("display:block;width:81.6%;height:100%;border-radius:999px;background:#2E7A72;")}
                      />
                    </span>
                    {' '}
                    <span
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:12.5px;color:var(--text);")}
                    >
                      34%
                    </span>
                    {' '}
                  </div>
                  <div style={s("display:flex;align-items:center;gap:10px;")}>
                    {' '}
                    <span style={s("width:96px;flex:none;font-size:11px;color:var(--muted);")}>
                      Competitor A
                    </span>
                    {' '}
                    <span
                      style={s("flex:1;height:8px;border-radius:999px;background:rgba(18,49,56,0.08);overflow:hidden;display:block;")}
                    >
                      <span
                        style={s("display:block;width:64.8%;height:100%;border-radius:999px;background:#5B9A96;")}
                      />
                    </span>
                    {' '}
                    <span
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:12.5px;color:var(--text);")}
                    >
                      27%
                    </span>
                    {' '}
                  </div>
                  <div style={s("display:flex;align-items:center;gap:10px;")}>
                    {' '}
                    <span style={s("width:96px;flex:none;font-size:11px;color:var(--muted);")}>
                      Private label
                    </span>
                    {' '}
                    <span
                      style={s("flex:1;height:8px;border-radius:999px;background:rgba(18,49,56,0.08);overflow:hidden;display:block;")}
                    >
                      <span
                        style={s("display:block;width:45.6%;height:100%;border-radius:999px;background:rgba(18,49,56,0.28);")}
                      />
                    </span>
                    {' '}
                    <span
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:12.5px;color:var(--text);")}
                    >
                      19%
                    </span>
                    {' '}
                  </div>
                </div>
                <div
                  style={s("position:relative;display:flex;align-items:center;justify-content:space-between;margin-top:16px;")}
                >
                  {' '}
                  <span
                    style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:var(--muted);")}
                  >
                    Category share
                  </span>
                  {' '}
                  <span
                    style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;padding:5px 9px;border-radius:999px;background:#D9A03C;color:#FFFFFF;")}
                  >
                    +3.4 pts
                  </span>
                  {' '}
                </div>
              </div>
            </div>
          </div>
          <div
            className="hv-11"
            style={s("display:flex;flex-direction:column;padding:clamp(28px,3vw,36px) clamp(24px,2.6vw,34px);background:var(--panel);transition:background .3s ease;")}
          >
            <div
              style={s("display:flex;align-items:baseline;justify-content:space-between;gap:16px;margin-bottom:18px;")}
            >
              {' '}
              <span
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(48px,4.6vw,64px);line-height:0.9;letter-spacing:-0.04em;color:rgba(18,49,56,0.14);")}
              >
                03
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
              >
                innovation
              </span>
              {' '}
            </div>
            <div
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(22px,2vw,25px);line-height:1.14;letter-spacing:-0.024em;text-wrap:pretty;color:var(--text);margin-bottom:10px;")}
            >
              Product innovation
            </div>
            <div style={s("font-size:16px;line-height:1.6;color:var(--muted);")}>
              From performance and insight to the next move worth making to grow your brand.
            </div>
            <div style={s("margin-top:auto;")}>
              <div
                style={s("position:relative;overflow:hidden;margin-top:26px;border-radius:12px;border:1px solid rgba(18,49,56,0.12);background:#FFFFFF;padding:18px;height:156px;display:flex;flex-direction:column;justify-content:flex-end;")}
              >
                <div
                  aria-hidden="true"
                  style={s("position:absolute;inset:0;pointer-events:none;background-image:linear-gradient(rgba(18,49,56,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(18,49,56,0.045) 1px,transparent 1px);background-size:26px 26px;")}
                />
                <div
                  style={s("position:relative;display:flex;flex-wrap:wrap;align-items:center;gap:0;min-width:0;")}
                >
                  <div style={s("display:flex;align-items:center;flex:1;min-width:0;")}>
                    <div style={s("display:flex;flex-direction:column;align-items:center;gap:9px;")}>
                      {' '}
                      <span
                        style={s("width:14px;height:14px;border-radius:50%;background:#2E7A72;opacity:0.3;box-shadow:0 0 0 0px rgba(217,160,60,0.16);")}
                      />
                      {' '}
                      <span
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;letter-spacing:0.1em;text-transform:uppercase;color:var(--muted);")}
                      >
                        Signal
                      </span>
                      {' '}
                    </div>
                    {' '}
                    <span
                      style={s("flex:1;height:2px;margin:0 8px 20px;background:repeating-linear-gradient(90deg,rgba(46,122,114,0.45) 0 6px,transparent 6px 11px);")}
                    />
                    {' '}
                  </div>
                  <div style={s("display:flex;align-items:center;flex:1;min-width:0;")}>
                    <div style={s("display:flex;flex-direction:column;align-items:center;gap:9px;")}>
                      {' '}
                      <span
                        style={s("width:14px;height:14px;border-radius:50%;background:#2E7A72;opacity:0.52;box-shadow:0 0 0 0px rgba(217,160,60,0.16);")}
                      />
                      {' '}
                      <span
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;letter-spacing:0.1em;text-transform:uppercase;color:var(--muted);")}
                      >
                        Concept
                      </span>
                      {' '}
                    </div>
                    {' '}
                    <span
                      style={s("flex:1;height:2px;margin:0 8px 20px;background:repeating-linear-gradient(90deg,rgba(46,122,114,0.45) 0 6px,transparent 6px 11px);")}
                    />
                    {' '}
                  </div>
                  <div style={s("display:flex;align-items:center;flex:1;min-width:0;")}>
                    <div style={s("display:flex;flex-direction:column;align-items:center;gap:9px;")}>
                      {' '}
                      <span
                        style={s("width:14px;height:14px;border-radius:50%;background:#2E7A72;opacity:0.74;box-shadow:0 0 0 0px rgba(217,160,60,0.16);")}
                      />
                      {' '}
                      <span
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;letter-spacing:0.1em;text-transform:uppercase;color:var(--muted);")}
                      >
                        Test
                      </span>
                      {' '}
                    </div>
                    {' '}
                    <span
                      style={s("flex:1;height:2px;margin:0 8px 20px;background:repeating-linear-gradient(90deg,rgba(46,122,114,0.45) 0 6px,transparent 6px 11px);")}
                    />
                    {' '}
                  </div>
                  <div style={s("display:flex;align-items:center;flex:none;")}>
                    <div style={s("display:flex;flex-direction:column;align-items:center;gap:9px;")}>
                      {' '}
                      <span
                        style={s("width:20px;height:20px;border-radius:50%;background:#D9A03C;opacity:1;box-shadow:0 0 0 6px rgba(217,160,60,0.16);")}
                      />
                      {' '}
                      <span
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;letter-spacing:0.1em;text-transform:uppercase;color:var(--muted);")}
                      >
                        Launch
                      </span>
                      {' '}
                    </div>
                  </div>
                </div>
                <div style={s("position:relative;display:flex;flex-wrap:wrap;gap:7px;margin-top:20px;")}>
                  {' '}
                  <span
                    style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;padding:5px 9px;border-radius:999px;background:#2E7A72;color:#FFFFFF;")}
                  >
                    12 concepts
                  </span>
                  <span
                    style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;padding:5px 9px;border-radius:999px;background:#5B9A96;color:#FFFFFF;")}
                  >
                    3 in test
                  </span>
                  <span
                    style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;padding:5px 9px;border-radius:999px;background:#123138;color:#FFFFFF;")}
                  >
                    1 shipping
                  </span>
                  {' '}
                </div>
              </div>
            </div>
          </div>
          <div
            className="hv-11"
            style={s("display:flex;flex-direction:column;padding:clamp(28px,3vw,36px) clamp(24px,2.6vw,34px);background:var(--panel);transition:background .3s ease;")}
          >
            <div
              style={s("display:flex;align-items:baseline;justify-content:space-between;gap:16px;margin-bottom:18px;")}
            >
              {' '}
              <span
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(48px,4.6vw,64px);line-height:0.9;letter-spacing:-0.04em;color:rgba(18,49,56,0.14);")}
              >
                04
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
              >
                media
              </span>
              {' '}
            </div>
            <div
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(22px,2vw,25px);line-height:1.14;letter-spacing:-0.024em;text-wrap:pretty;color:var(--text);margin-bottom:10px;")}
            >
              Content & media optimization
            </div>
            <div style={s("font-size:16px;line-height:1.6;color:var(--muted);")}>
              Content, spend, reach, and return across every channel, brought into one view.
            </div>
            <div style={s("margin-top:auto;")}>
              <div
                style={s("position:relative;overflow:hidden;margin-top:26px;border-radius:12px;border:1px solid rgba(18,49,56,0.12);background:#FFFFFF;padding:18px;height:156px;display:flex;flex-direction:column;justify-content:flex-end;")}
              >
                <div
                  aria-hidden="true"
                  style={s("position:absolute;inset:0;pointer-events:none;background-image:linear-gradient(rgba(18,49,56,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(18,49,56,0.045) 1px,transparent 1px);background-size:26px 26px;")}
                />
                <div style={s("position:relative;display:flex;align-items:center;gap:20px;")}>
                  <div
                    style={s("width:78px;height:78px;flex:none;border-radius:50%;background:conic-gradient(#2E7A72 0 42%,#5B9A96 42% 68%,#D9A03C 68% 88%,rgba(18,49,56,0.16) 88% 100%);display:flex;align-items:center;justify-content:center;")}
                  >
                    {' '}
                    <span
                      style={s("width:48px;height:48px;border-radius:50%;background:#FFFFFF;display:flex;align-items:center;justify-content:center;font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;color:var(--text);")}
                    >
                      3.8x
                    </span>
                    {' '}
                  </div>
                  <div style={s("flex:1;display:flex;flex-direction:column;gap:9px;min-width:0;")}>
                    <div
                      style={s("display:flex;align-items:center;gap:9px;font-size:11px;color:var(--muted);")}
                    >
                      {' '}
                      <span style={s("width:8px;height:8px;flex:none;border-radius:2px;background:#2E7A72;")} />
                      <span style={s("flex:1;")}>
                        Retail media
                      </span>
                      <span style={s("font-family:var(--mono);font-weight:var(--mono-w);color:var(--text);")}>
                        42%
                      </span>
                      {' '}
                    </div>
                    <div
                      style={s("display:flex;align-items:center;gap:9px;font-size:11px;color:var(--muted);")}
                    >
                      {' '}
                      <span style={s("width:8px;height:8px;flex:none;border-radius:2px;background:#5B9A96;")} />
                      <span style={s("flex:1;")}>
                        Social
                      </span>
                      <span style={s("font-family:var(--mono);font-weight:var(--mono-w);color:var(--text);")}>
                        26%
                      </span>
                      {' '}
                    </div>
                    <div
                      style={s("display:flex;align-items:center;gap:9px;font-size:11px;color:var(--muted);")}
                    >
                      {' '}
                      <span style={s("width:8px;height:8px;flex:none;border-radius:2px;background:#D9A03C;")} />
                      <span style={s("flex:1;")}>
                        Search
                      </span>
                      <span style={s("font-family:var(--mono);font-weight:var(--mono-w);color:var(--text);")}>
                        20%
                      </span>
                      {' '}
                    </div>
                  </div>
                </div>
                <div
                  style={s("position:relative;margin-top:16px;font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:var(--muted);")}
                >
                  Blended ROAS · trailing 4 weeks
                </div>
              </div>
            </div>
          </div>
          <div
            className="hv-11"
            style={s("display:flex;flex-direction:column;padding:clamp(28px,3vw,36px) clamp(24px,2.6vw,34px);background:var(--panel);transition:background .3s ease;")}
          >
            <div
              style={s("display:flex;align-items:baseline;justify-content:space-between;gap:16px;margin-bottom:18px;")}
            >
              {' '}
              <span
                style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(48px,4.6vw,64px);line-height:0.9;letter-spacing:-0.04em;color:rgba(18,49,56,0.14);")}
              >
                05
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
              >
                sales
              </span>
              {' '}
            </div>
            <div
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(22px,2vw,25px);line-height:1.14;letter-spacing:-0.024em;text-wrap:pretty;color:var(--text);margin-bottom:10px;")}
            >
              Sales & retail
            </div>
            <div style={s("font-size:16px;line-height:1.6;color:var(--muted);")}>
              Shipments, consumption, and distribution — finally reconciled across key customers.
            </div>
            <div style={s("margin-top:auto;")}>
              <div
                style={s("position:relative;overflow:hidden;margin-top:26px;border-radius:12px;border:1px solid rgba(18,49,56,0.12);background:#FFFFFF;padding:18px;height:156px;display:flex;flex-direction:column;justify-content:flex-end;")}
              >
                <div
                  aria-hidden="true"
                  style={s("position:absolute;inset:0;pointer-events:none;background-image:linear-gradient(rgba(18,49,56,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(18,49,56,0.045) 1px,transparent 1px);background-size:26px 26px;")}
                />
                <div style={s("position:relative;height:84px;")}>
                  {' '}
                  <svg
                    viewBox="0 0 260 84"
                    preserveAspectRatio="none"
                    style={s("width:100%;height:100%;display:block;")}
                  >
                    {' '}
                    <polyline
                      points="6,66 41,58 76,62 111,44 146,48 181,30 216,26 251,16"
                      fill="none"
                      stroke="#2E7A72"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    {' '}
                    <polyline
                      points="6,74 41,70 76,60 111,64 146,52 181,46 216,40 251,32"
                      fill="none"
                      stroke="#D9A03C"
                      strokeWidth="2.5"
                      strokeDasharray="5 5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    {' '}
                    <circle cx="251" cy="16" r="4" fill="#2E7A72" />
                    {' '}
                  </svg>
                  {' '}
                </div>
                <div
                  style={s("position:relative;display:flex;flex-wrap:wrap;gap:14px;margin-top:14px;font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:var(--muted);")}
                >
                  {' '}
                  <span style={s("display:flex;align-items:center;gap:7px;")}>
                    <span style={s("width:16px;height:2px;background:#2E7A72;")} />
                    Shipments
                  </span>
                  {' '}
                  <span style={s("display:flex;align-items:center;gap:7px;")}>
                    <span
                      style={s("width:16px;height:2px;background:repeating-linear-gradient(90deg,#D9A03C 0 4px,transparent 4px 7px);")}
                    />
                    Consumption
                  </span>
                  {' '}
                  <span style={s("margin-left:auto;color:#2E7A72;")}>
                    92% reconciled
                  </span>
                  {' '}
                </div>
              </div>
            </div>
          </div>
          <div aria-hidden="true" style={s("background:var(--panel);")} />
        </div>
      </div>
    </section>
  );
}
